export default function initMainLinkTargeter() {
    // Si on est sur le main on ajoute pas les target _blank
    if (document.body.classList.contains('main')) {
        return;
    }

    const links = Array.from(document.querySelectorAll<HTMLAnchorElement>('a.main'));

    links.forEach((link: HTMLAnchorElement) => {
        new MainLinkTargeter(link);
    });
}

class MainLinkTargeter {
    private link: HTMLAnchorElement;

    constructor(link: HTMLAnchorElement) {
        this.link = link;
        this.processLink();
    }

    private processLink() {
        const href = this.link.getAttribute('href');
        if (!href) return;

        this.link.target = '_blank';

        if (!this.link.rel.includes('noopener')) {
            this.link.rel += (this.link.rel ? ' ' : '') + 'noopener';
        }
    }
}